interface MaydayProps {
  onNavigate: (to: string) => void;
}

interface GameEntry {
  slug: string;
  name: string;
  blurb: string;
  ready: boolean;
}

const GAMES: readonly GameEntry[] = [
  {
    slug: "builder",
    name: "Mayday / Pan-Pan script builder",
    blurb:
      "Pick the call type (Mayday for distress, Pan-Pan for urgency), fill in your vessel's details, and the complete VHF transcript appears below for you to read on Channel 16.",
    ready: true,
  },
  {
    slug: "nato",
    name: "NATO phonetic alphabet",
    blurb:
      "Letter → code-word flash cards. Alfa, Bravo, Charlie … plus the standard digit pronunciations (Tree, Fife, Niner).",
    ready: true,
  },
  {
    slug: "nato-review",
    name: "NATO phonetic — audio review",
    blurb:
      "Press-to-hear grid covering every letter and digit. Useful for ear training without the flashcards scoring loop.",
    ready: true,
  },
  {
    slug: "vhf",
    name: "VHF procedure — channels + call types",
    blurb:
      "Quick-fire drill on the SRC essentials: which channel for the situation (16, 70, 13, 67, 80, ...) and which call type (Mayday / Pan Pan / Securité / routine) for the scenario.",
    ready: true,
  },
];

export function Mayday({ onNavigate }: MaydayProps) {
  return (
    <>
      <p className="muted">
        Voice distress on VHF Channel 16. <strong>Only</strong> use a
        Mayday call when the vessel or a person is in grave and imminent
        danger and requires immediate assistance — otherwise use
        Pan-Pan (urgency) or Securité (safety).
      </p>

      <div className="card" style={{ borderColor: "#c0382b" }}>
        <h3 style={{ marginTop: 0, color: "#c0382b" }}>Mayday — DISTRESS</h3>
        <p className="small" style={{ margin: "0 0 8px" }}>
          Grave and imminent danger to vessel or life. Requires
          IMMEDIATE assistance.
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 0 }}>
          <li>Ensure VHF is switched on and tuned to Channel 16.</li>
          <li>
            Press and hold the red <strong>DSC</strong> button for ~6
            seconds.
          </li>
          <li>
            Follow up with a voice call on Channel 16 using the script
            builder below.
          </li>
        </ol>
      </div>

      <div className="card" style={{ borderColor: "#b45309" }}>
        <h3 style={{ marginTop: 0, color: "#b45309" }}>Pan-Pan — URGENCY</h3>
        <p className="small" style={{ margin: "0 0 8px" }}>
          A very urgent message about the safety of a vessel or person,
          but NOT in grave and imminent danger. Examples: engine
          failure in safe water, medical advice request, MOB recovered
          but injured, partially aground at HW.
        </p>
        <ol style={{ paddingLeft: 20, marginBottom: 0 }}>
          <li>Voice call on Channel 16 — no DSC distress button.</li>
          <li>
            Open the call to "all stations" rather than naming a
            recipient.
          </li>
          <li>
            Use the same builder below — switch the tab at the top to
            Pan-Pan.
          </li>
        </ol>
      </div>

      <h2 style={{ marginTop: 32 }}>Drills</h2>
      {GAMES.map((g) => (
        <div key={g.slug} className="card">
          <h3 style={{ marginBottom: 4 }}>{g.name}</h3>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {g.blurb}
          </p>
          <button
            onClick={() => onNavigate(`/play/mayday/${g.slug}`)}
            className="secondary"
          >
            Open
          </button>
        </div>
      ))}

      <button className="secondary" onClick={() => onNavigate("/play")}>
        ← Back to Play
      </button>
    </>
  );
}
